
(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.body.classList.toggle('fr-scrolled', window.scrollY > 10);
  window.addEventListener('scroll', () => {
    document.body.classList.toggle('fr-scrolled', window.scrollY > 10);
  }, { passive: true });

  const revealEls = document.querySelectorAll('.fr-reveal');
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach((el) => observer.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  if (prefersReducedMotion || !window.matchMedia('(hover: hover)').matches) return;

  const tiltElements = document.querySelectorAll('.fr-tilt');

  tiltElements.forEach((el) => {
    const intensity = parseFloat(el.dataset.tilt || '8');
    const reset = () => {
      el.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) translateY(0)';
    };

    el.addEventListener('mousemove', (event) => {
      const rect = el.getBoundingClientRect();
      const px = (event.clientX - rect.left) / rect.width;
      const py = (event.clientY - rect.top) / rect.height;
      const rotateY = (px - 0.5) * intensity;
      const rotateX = (0.5 - py) * intensity;
      el.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-2px)`;
    });

    el.addEventListener('mouseleave', reset);
    el.addEventListener('blur', reset);
  });
})();
